import React from 'react';

export function ParksAttractionsIcon({ className, width = 36, height = 36 }) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.7679 15.1676H18.5933L25.787 7.97393L25.1671 7.35408L17.9735 14.5478V4.37402H17.0967V14.5478L9.90216 7.35408L9.2823 7.97393L16.4769 15.1676H6.30225V16.0444H16.4769L9.2823 23.2389L9.90216 23.8588L17.0967 16.6642V26.8388H17.9735V16.6651L25.1671 23.8588L25.787 23.2389L18.5933 16.0444H28.7679V15.1676Z"
        fill="#CCD6DD"
      />
      <path
        d="M17.5349 2.93359C10.5367 2.93359 4.86328 8.60701 4.86328 15.6052C4.86328 22.6033 10.5367 28.2768 17.5349 28.2768C24.5339 28.2768 30.2073 22.6033 30.2073 15.6052C30.2065 8.60701 24.533 2.93359 17.5349 2.93359ZM17.5349 26.3278C11.6125 26.3278 6.81228 21.5276 6.81228 15.6052C6.81228 9.68277 11.6125 4.8826 17.5349 4.8826C23.4564 4.8826 28.2574 9.68277 28.2574 15.6052C28.2574 21.5276 23.4573 26.3278 17.5349 26.3278Z"
        fill="#AAB8C2"
      />
      <path
        d="M17.5344 22.2045C13.8959 22.2045 10.936 19.2437 10.936 15.6052C10.936 11.9667 13.8959 9.00684 17.5344 9.00684C21.1738 9.00684 24.1345 11.9667 24.1345 15.6052C24.1345 19.2437 21.1747 22.2045 17.5344 22.2045ZM17.5344 10.322C14.621 10.322 12.2512 12.6927 12.2512 15.6052C12.2512 18.5178 14.6219 20.8894 17.5344 20.8894C20.4487 20.8894 22.8194 18.5186 22.8194 15.6052C22.8194 12.6918 20.4487 10.322 17.5344 10.322Z"
        fill="#AAB8C2"
      />
      <path
        d="M25.6758 31.8973L18.3322 15.8143C18.3138 15.7739 18.2814 15.7476 18.2577 15.7117C18.2244 15.66 18.1946 15.6082 18.1499 15.5635C18.1051 15.5188 18.0534 15.489 18.0008 15.4557C17.9649 15.432 17.9386 15.3996 17.8982 15.3812C17.8877 15.3768 17.8772 15.3785 17.8675 15.3742C17.8114 15.3505 17.7518 15.3443 17.6913 15.3329C17.6378 15.3233 17.5852 15.3066 17.5318 15.3066C17.4844 15.3066 17.4388 15.3224 17.3906 15.3303C17.3248 15.3417 17.26 15.3496 17.1986 15.375C17.189 15.3794 17.1784 15.3777 17.1688 15.382C17.1302 15.3996 17.1039 15.432 17.0688 15.4539C17.0154 15.4881 16.9627 15.5188 16.9172 15.5635C16.8724 15.6082 16.8418 15.6608 16.8084 15.7135C16.7856 15.7485 16.7532 15.7748 16.7357 15.8143L9.39469 31.8973C9.19392 32.3374 9.38768 32.8582 9.82781 33.059C9.94617 33.1124 10.0698 33.1379 10.1917 33.1379C10.5239 33.1379 10.8422 32.9476 10.9895 32.625L17.5344 18.2893L24.0793 32.625C24.2266 32.9476 24.5448 33.1379 24.878 33.1379C24.9999 33.1379 25.1226 33.1124 25.241 33.0581C25.6828 32.8573 25.8766 32.3374 25.6758 31.8973Z"
        fill="#8899A6"
      />
      <path
        d="M13.0691 33.275H7.96561C7.48165 33.275 7.08887 32.8831 7.08887 32.3982C7.08887 31.9134 7.48165 31.5215 7.96561 31.5215H13.0691C13.5531 31.5215 13.9459 31.9134 13.9459 32.3982C13.9459 32.8831 13.5531 33.275 13.0691 33.275ZM27.0962 33.275H21.9935C21.5087 33.275 21.1168 32.8831 21.1168 32.3982C21.1168 31.9134 21.5087 31.5215 21.9935 31.5215H27.0962C27.581 31.5215 27.9729 31.9134 27.9729 32.3982C27.9729 32.8831 27.581 33.275 27.0962 33.275Z"
        fill="#553788"
      />
      <path
        d="M20.4197 27.8554C20.4197 29.2012 19.329 30.2919 17.9832 30.2919H17.0082C15.6624 30.2919 14.5718 29.2012 14.5718 27.8554C14.5718 26.5096 15.6624 25.4189 17.0082 25.4189H17.9832C19.3281 25.4189 20.4197 26.5096 20.4197 27.8554Z"
        fill="#744EAA"
      />
      <path
        d="M20.3697 27.3678C20.1444 26.2553 19.1616 25.418 17.9823 25.418H17.0074C15.8282 25.418 14.8453 26.2544 14.6191 27.3678H20.3697Z"
        fill="#CBB7EA"
      />
      <path
        d="M11.4182 24.9687C11.4182 26.3145 10.3275 27.4052 8.98172 27.4052H8.00678C6.66098 27.4052 5.57031 26.3145 5.57031 24.9687C5.57031 23.6229 6.66098 22.5322 8.00678 22.5322H8.98172C10.3275 22.5322 11.4182 23.6229 11.4182 24.9687Z"
        fill="#5C913B"
      />
      <path
        d="M11.3679 24.4821C11.1425 23.3695 10.1597 22.5322 8.98048 22.5322H8.00642C6.82719 22.5322 5.84436 23.3686 5.61816 24.4821H11.3679Z"
        fill="#C6E5B3"
      />
      <path
        d="M32.425 17.1718C32.425 18.5176 31.3344 19.6083 29.9886 19.6083H29.0136C27.6678 19.6083 26.5771 18.5176 26.5771 17.1718C26.5771 15.826 27.6678 14.7354 29.0136 14.7354H29.9886C31.3344 14.7345 32.425 15.8251 32.425 17.1718Z"
        fill="#3B94D9"
      />
      <path
        d="M32.3757 16.6843C32.1503 15.5717 31.1675 14.7344 29.9883 14.7344H29.0134C27.835 14.7344 26.8513 15.5708 26.626 16.6843H32.3757Z"
        fill="#BBDDF5"
      />
      <path
        d="M29.5027 8.6269C29.5027 9.9727 28.412 11.0634 27.0662 11.0634H26.0913C24.7455 11.0634 23.6548 9.9727 23.6548 8.6269C23.6548 7.2811 24.7455 6.19043 26.0913 6.19043H27.0662C28.412 6.19043 29.5027 7.2811 29.5027 8.6269Z"
        fill="#5C913B"
      />
      <path
        d="M29.4533 8.13933C29.228 7.02674 28.2451 6.18945 27.0659 6.18945H26.091C24.9126 6.18945 23.9289 7.02587 23.7036 8.13933H29.4533Z"
        fill="#C6E5B3"
      />
      <path
        d="M29.5027 24.9687C29.5027 26.3145 28.412 27.4052 27.0662 27.4052H26.0913C24.7455 27.4052 23.6548 26.3145 23.6548 24.9687C23.6548 23.6229 24.7455 22.5322 26.0913 22.5322H27.0662C28.412 22.5322 29.5027 23.6229 29.5027 24.9687Z"
        fill="#BE1931"
      />
      <path
        d="M29.4533 24.4821C29.228 23.3695 28.2451 22.5322 27.0659 22.5322H26.091C24.9126 22.5322 23.9289 23.3686 23.7036 24.4821H29.4533Z"
        fill="#F4ABBA"
      />
      <path
        d="M11.4182 8.6269C11.4182 9.9727 10.3275 11.0634 8.98172 11.0634H8.00678C6.66098 11.0634 5.57031 9.9727 5.57031 8.6269C5.57031 7.2811 6.66098 6.19043 8.00678 6.19043H8.98172C10.3275 6.19043 11.4182 7.2811 11.4182 8.6269Z"
        fill="#BE1931"
      />
      <path
        d="M11.3679 8.13933C11.1425 7.02674 10.1597 6.18945 8.98048 6.18945H8.00642C6.82719 6.18945 5.84436 7.02587 5.61816 8.13933H11.3679Z"
        fill="#F4ABBA"
      />
      <path
        d="M20.4197 4.23335C20.4197 5.57915 19.329 6.66982 17.9832 6.66982H17.0082C15.6624 6.66982 14.5718 5.57915 14.5718 4.23335C14.5718 2.88755 15.6624 1.79688 17.0082 1.79688H17.9832C19.3281 1.796 20.4197 2.88667 20.4197 4.23335Z"
        fill="#744EAA"
      />
      <path
        d="M20.3697 3.74578C20.1444 2.63319 19.1616 1.7959 17.9823 1.7959H17.0074C15.8282 1.7959 14.8453 2.63231 14.6191 3.74578H20.3697Z"
        fill="#CBB7EA"
      />
      <path
        d="M8.49427 17.1718C8.49427 18.5176 7.4036 19.6083 6.0578 19.6083H5.08198C3.73618 19.6083 2.64551 18.5176 2.64551 17.1718C2.64551 15.826 3.73618 14.7354 5.08198 14.7354H6.05692C7.40272 14.7345 8.49427 15.8251 8.49427 17.1718Z"
        fill="#3B94D9"
      />
      <path
        d="M8.44392 16.6843C8.2186 15.5717 7.23577 14.7344 6.05655 14.7344H5.08161C3.90239 14.7344 2.91956 15.5708 2.69336 16.6843H8.44392Z"
        fill="#BBDDF5"
      />
      <path
        d="M14.8682 15.6056C14.8682 14.1327 16.0623 12.9395 17.5343 12.9395C19.0073 12.9395 20.2014 14.1336 20.2014 15.6056C20.2014 17.0777 19.0073 18.2718 17.5343 18.2718C16.0623 18.2727 14.8682 17.0786 14.8682 15.6056Z"
        fill="#553788"
      />
    </svg>
  );
}
